import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";

interface Props {
  type: string;
  value: string;
}

interface dashboardProps {
  startDate: string;
  endDate: string;
}

export const getDashboard = createApi({
  reducerPath: "getDashboard",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getStates: builder.query<any, void>({
      query: () => ({
        url: `states`,
        method: "GET",
      }),
    }),
    validateBusiness: builder.mutation<any, Props>({
      query: (body) => ({
        url: `onboarding/validateData`,
        method: "POST",
        body,
      }),
    }),
    dashboardStats: builder.mutation<any, dashboardProps>({
      query: (body) => ({
        url: `orders/clusterStatsWithDateRange`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetStatesQuery,
  useValidateBusinessMutation,
  useDashboardStatsMutation,
} = getDashboard;
